import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";

import { FlexBox } from "~frontend/components/FlexBox";

export const ErroredTenDlcCampaigns = ({
  campaigns,
}: {
  campaigns?: {
    error?: string | null;
    id?: string | null;
    retoolId?: string | null;
    tcrCampaignId?: string | null;
    description?: string | null;
    submittedAt?: number;
  }[];
}): ReactElement => {
  return (
    <>
      {(campaigns || []).map(campaign => (
        <Box
          data-testid="errored-campaign"
          key={campaign.error}
          p={3}
          mb={3}
          sx={{ backgroundColor: "#ffcdd2" }}
        >
          <Typography variant="body1Bold">Error detected</Typography>

          <FlexBox sx={{ pt: 1 }} flexDirection="column">
            <Typography variant="body2">
              <strong>Error:</strong> {campaign.error || "--"}
            </Typography>
            <Typography variant="body2">
              <strong>Campaign ID:</strong> {campaign.tcrCampaignId || "--"}
            </Typography>
            <Typography variant="body2">
              <strong>Retool ID:</strong>{" "}
              {campaign.retoolId || campaign.id || "--"}
            </Typography>
          </FlexBox>
        </Box>
      ))}
    </>
  );
};
